import React, { useEffect, useState } from "react";
import DashboardContainer from "../../../components/DashboardContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DataFetching from "../../../helper/DataFetching";
import renderDataTable from "../../../helper/renderDataTable";
import { formatMoment } from "../../../helper/CommonFunction";
import Breadcrumb from "../../../components/Breadcrumb";
import { FaUser } from "react-icons/fa";

const Domain = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userLoginToken } = useSelector((state) => state.user);

  const [filteredData, setFilteredData] = useState([]);
  const [pending, setPending] = useState(true);
  const [resetSearch, setResetSearch] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const fetchData = async () => {
    setPending(true);

    const body = {
      page: currentPage - 1,
      perpage: pageLimit,
    };

    DataFetching(
      setPending,
      "/get_domain.php",
      "POST",
      userLoginToken,
      dispatch,
      navigate,
      setFilteredData,
      setTotalPages,
      body,
      setResetSearch,
      resetSearch
    );
  };

  // Render the DataTable component
  useEffect(() => {
    if (!resetSearch) {
      return;
    }
    fetchData();
  }, [currentPage, pageLimit, location, resetSearch]);

  const column = [
  {
    name: (
      <div style={{ padding: "12px 16px", color: "#000000", fontWeight: 600 }}>
        App Name
      </div>
    ),
    selector: (row) => (
      <div
        style={{
          padding: "12px 16px",
          borderRight: "1px solid #FDE8CD",
          width: "100%",
          whiteSpace: "nowrap",
        }}
      >
        {row.app_name}
      </div>
    ),
    sortable: true,
    minWidth: "200px",
  },
  {
    name: (
      <div style={{ padding: "12px 16px", color: "#000000", fontWeight: 600 }}>
        App Url
      </div>
    ),
    selector: (row) => (
      <div
        style={{
          padding: "12px 16px",
          borderRight: "1px solid #FDE8CD",
          width: "100%",
          whiteSpace: "nowrap",
        }}
      >
        {row.domain_name}
      </div>
    ),
    sortable: true,
    minWidth: "220px",
  },
  {
    name: (
      <div style={{ padding: "12px 16px", color: "#000000", fontWeight: 600 }}>
        User Email
      </div>
    ),
    selector: (row) => (
      <div
        style={{
          padding: "12px 16px",
          borderRight: "1px solid #FDE8CD",
          width: "100%",
          whiteSpace: "nowrap",
        }}
      >
        {row.email}
      </div>
    ),
    sortable: true,
    minWidth: "220px",
  },
  {
    name: (
      <div style={{ padding: "12px 16px", color: "#000000", fontWeight: 600 }}>
        Created Date
      </div>
    ),
    selector: (row) => (
      <div
        style={{
          padding: "12px 16px",
          width: "100%",
          whiteSpace: "nowrap",
        }}
      >
        {formatMoment(row.created_date)}
      </div>
    ),
    sortable: true,
    minWidth: "180px",
  },
];

  return (
    <>
      <Breadcrumb pageName="User Domain" />
      <DashboardContainer>
        <div>
          <div className="p-4 w-full">
            <div
              className="w-full sm:w-[25%] px-4 py-3 bg-gradient-to-br from-[#FFF4E5] to-[#FEF3E5] border border-[#FDE8CD]"
              style={{ borderRadius: "1.4rem 0.5rem 1.4rem 0.5rem" }}
            >
              <div className="flex justify-between items-center">
                <p className="text-4xl font-extrabold text-[#1C1410]">
                  {filteredData?.length || 0}
                </p>
                <span
                  className="w-11 h-11 shrink-0 flex items-center justify-center text-[#D97706] text-lg"
                  style={{
                    background: "linear-gradient(145deg, #FFFFFF, #FDE8CD)",
                    borderRadius: "58% 42% 55% 45% / 45% 55% 42% 58%",
                  }}
                >
                  <FaUser />
                </span>
              </div>
              <p className="text-[#8A7560] font-semibold mt-4 mb-1 text-sm">
                TOTAL USER DOMAIN
              </p>
            </div>

            {/* <div className="flex justify-end space-x-2 mt-4">
              <button className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600">
                PDF
              </button>
              <button className="bg-purple-500 text-white px-3 py-1 rounded hover:bg-purple-600">
                CSV
              </button>
            </div> */}
            <div className="py-3 w-full overflow-x-auto">
  <div style={{ width: "max-content", minWidth: "100%" }}>
    {renderDataTable(
      filteredData,
      column,
      pending,
      currentPage,
      setPageLimit,
      setCurrentPage,
      totalPages,
      pageLimit,
      setResetSearch,
      dispatch,
      navigate
    )}
  </div>
</div>
          </div>
        </div>
      </DashboardContainer>
    </>
  );
};

export default Domain;